import logoSantaClara from '../../assets/images/logo-santa-clara-real.png';
import logoSantaClaraFooter from '../../assets/images/logo-santa-clara-footer.png';

interface LogoSantaClaraProps {
  className?: string;
  variant?: 'color' | 'footer';
}

export function LogoSantaClara({
  className = "w-48",
  variant = 'color'
}: LogoSantaClaraProps) {
  const src = variant === 'footer' ? logoSantaClaraFooter : logoSantaClara;
  return <img src={src} alt="Santa Clara Centro Médico" className={className} />;
}

export function LogoSantaClaraIcon({
  className = "w-10",
  variant = 'color'
}: { className?: string; variant?: 'color' | 'footer' }) {
  const src = variant === 'footer' ? logoSantaClaraFooter : logoSantaClara;
  return <img src={src} alt="Santa Clara Centro Médico" className={className} />;
}

export function LogoSantaClaraHorizontal({
  className = "w-56",
  variant = 'color'
}: { className?: string; variant?: 'color' | 'footer' }) {
  const src = variant === 'footer' ? logoSantaClaraFooter : logoSantaClara;
  return <img src={src} alt="Santa Clara Centro Médico" className={className} />;
}
